var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11938 1.62545C4.41858 1.62545 4.66113 1.3829 4.66113 1.08371C4.66113 0.784509 4.41858 0.541962 4.11938 0.541962C3.82018 0.541962 3.57764 0.784509 3.57764 1.08371C3.57764 1.3829 3.82018 1.62545 4.11938 1.62545Z",
    fill: "#4E5574"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20442 0.869017C5.44433 0.869017 5.63882 0.674529 5.63882 0.434615C5.63882 0.194702 5.44433 0.000213623 5.20442 0.000213623C4.96451 0.000213623 4.77002 0.194702 4.77002 0.434615C4.77002 0.674529 4.96451 0.869017 5.20442 0.869017Z",
    fill: "#4E5574"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0259 7.40012L4.77003 3.79408V2.71059H5.4208V1.95248H1.73425V2.71059H2.38502V3.79408L0.130824 7.40012C0.0469624 7.55274 0 7.72885 0 7.91503C0 8.5138 0.484719 9.00019 1.08517 9.00019H6.07156C6.67033 9.00019 7.15673 8.51547 7.15673 7.91503C7.15673 7.72885 7.10977 7.55274 7.0259 7.40012ZM1.85669 6.07008L3.1448 4.01044V2.70891H4.01193V4.01044L5.30004 6.07008H1.85669Z",
    fill: "#4E5574"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotion);
export default __webpack_public_path__ + "static/media/potion.762fe703f45c774c4ef5f56fe00c65bf.svg";
export { ForwardRef as ReactComponent };